import React, { useState } from 'react';
import { Form as SemanticForm } from 'semantic-ui-react';
import styled from 'styled-components';
import SemanticInput from '../../../components/SemanticInput';
import swal from 'sweetalert';

const Form = ({
  isBusy,
  setIsBusy,
  partner: current,
  service,
  onSuccess,
  children,
}) => {
  const [partner, setPartner] = useState({ ...current });
  const [validations, setValidations] = useState({
    name: false,
  });

  const handledOnSubmit = async (event) => {
    let success = false,
      result = null;
    try {
      setIsBusy(true);
      event.preventDefault();

      const firstInvalid = isInvalid();

      if (!firstInvalid) {
        let partnerDTO = { ...partner };
        result = await (!partner._id
          ? service.create(partnerDTO)
          : service.patch(partner._id, partnerDTO));

        success = true;
      }
    } catch (error) {
      console.error('error :>> ', error);
      await swal('Error', `Partner not added`, 'error');
    } finally {
      setIsBusy(false);

      if (success) {
        await swal('Done', 'Finished', 'success');
        onSuccess && onSuccess(result);
      }
    }
  };

  const isInvalid = () => {
    let firstInvalid = null;

    const newValidations = Object.keys(validations).reduce((prev, field) => {
      const ret = { ...prev, [field]: partner[field] ? false : true };

      firstInvalid = firstInvalid || (ret[field] && field);

      return ret;
    }, {});

    setValidations(newValidations);

    return firstInvalid;
  };

  const handledChange = (_, { name, value }) =>
    setPartner({ ...partner, [name]: value });

  return (
    <SemanticForm onSubmit={handledOnSubmit} loading={isBusy}>
      <FormGrid>
        <div style={{ gridArea: 'name' }}>
          <SemanticInput
            placeholder="Name"
            label="Name *"
            name="name"
            value={partner.name || ''}
            onChange={handledChange}
          />
        </div>
      </FormGrid>
      {children}
    </SemanticForm>
  );
};

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto auto;
  grid-gap: 1em;
  grid-template-areas: 'name . .' '. . .';
`;

export default Form;
